<template>
    <div class="container">
        <div class="offer-flats section">
            <h2 class="h3 mb-2">
                Filter
            </h2>
            <div class="filter d-flex flex-column flex-md-row align-items-md-center mb-3 mb-md-4">
                <div
                    v-if="filtersShow"
                    class="filters d-flex flex-column flex-md-row align-items-center"
                >
                    <template v-for="(filter, key) in filters">
                        <div
                            v-if="!['area_min', 'area_max'].includes(key)"
                            class="filter-select w-100"
                        >
                            <label :for="key">
                                {{ filter.name }}:
                            </label>
                            <select
                                :id="key"
                                v-model="form.filter[key]"
                                @change="getItems(true)"
                            >
                                <option :value="null" selected>-nešpecifikované-</option>
                                <template v-for="item in filter.values">
                                    <option :value="item.value">
                                        {{ item.text }}
                                    </option>
                                </template>
                            </select>
                        </div>
                    </template>
                    <div class="filter-input w-100">
                        <label>Užitková plocha:</label>
                        <div class="d-flex align-items-center">
                            <div class="position-relative">
                                <input
                                    type="number"
                                    v-model="form.filter.area_min"
                                    @change="getItems(true)"
                                />
                                <div class="filter-input-append">㎡</div>
                            </div>
                            <span class="px-2">-</span>
                            <div class="position-relative">
                                <input
                                    type="number"
                                    v-model="form.filter.area_max"
                                    @change="getItems(true)"
                                />
                                <div class="filter-input-append">㎡</div>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    class="show-contact-form-button btn btn--secondary ml-md-auto mt-3 mt-md-0"
                >Kontaktujte ma
                    <span class="ml-2 align-baseline">
                        <img src="img/icons/chevron-right-white.svg" class="btn-icon" alt="chevron right">
                    </span>
                </button>
            </div>
            <div class="flat-table-list">
                <div class="table-responsive mb-3 mb-md-4">
                    <table class="table mb-0">
                        <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">POSCHODIE</th>
                            <th scope="col">TYP</th>
                            <th scope="col">ČISTÁ ÚŽ. PLOCHA</th>
                            <th class="text-center">LOGGIA</th>
                            <th class="text-center">BALKÓN</th>
                            <th class="text-center">TERASA</th>
                            <!-- <th class="text-center">CENA</th> -->
                            <th class="text-center">STAV</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-if="!loading">
                            <template v-if="items.length">
                                <tr
                                    v-for="(item, index) in items"
                                    :key="index"
                                >
                                    <td>
                                        <a 
                                            :href="item.state.id === 3 ? '/ponuka-bytov/'+item.apartmentHousePattern+'/'+item.pattern : '#'"
                                            @click="item.state.id === 3 ? null : $event.preventDefault()"
                                            data-mobile="Číslo"
                                        >
                                            {{ item.title }}
                                        </a>
                                    </td>
                                    <td>
                                        <a 
                                            :href="item.state.id === 3 ? '/ponuka-bytov/'+item.apartmentHousePattern+'/'+item.pattern : '#'"
                                            @click="item.state.id === 3 ? null : $event.preventDefault()"
                                            data-mobile="Poschodie"
                                        >
                                            {{ item.apartmentHouseName }}
                                        </a>
                                    </td>
                                    <td>
                                        <a 
                                            :href="item.state.id === 3 ? '/ponuka-bytov/'+item.apartmentHousePattern+'/'+item.pattern : '#'"
                                            @click="item.state.id === 3 ? null : $event.preventDefault()"
                                            data-mobile="Typ"
                                        >
                                            {{ item.number_rooms }}-izbový
                                        </a>
                                    </td>
                                    <td style="min-width: 110px;">
                                        <a 
                                            :href="item.state.id === 3 ? '/ponuka-bytov/'+item.apartmentHousePattern+'/'+item.pattern : '#'"
                                            @click="item.state.id === 3 ? null : $event.preventDefault()"
                                            data-mobile="ČISTÁ ÚŽ. PLOCHA"
                                        >
                                            {{ item.area }} M<sup>2</sup>
                                        </a>
                                    </td>
                                    <td class="text-center" style="min-width: 110px;">
                                        <a 
                                            :href="item.state.id === 3 ? '/ponuka-bytov/'+item.apartmentHousePattern+'/'+item.pattern : '#'"
                                            @click="item.state.id === 3 ? null : $event.preventDefault()"
                                            data-mobile="Loggia"
                                        >
                                            {{ item.logia_area }} M<sup>2</sup>
                                        </a>
                                    </td>
                                    <td class="text-center" style="min-width: 110px;">
                                        <a 
                                            :href="item.state.id === 3 ? '/ponuka-bytov/'+item.apartmentHousePattern+'/'+item.pattern : '#'"
                                            @click="item.state.id === 3 ? null : $event.preventDefault()"
                                            data-mobile="Balkón"
                                        >
                                            {{ item.balcony_area }} M<sup>2</sup>
                                        </a>
                                    </td>
                                    <td class="text-center" style="min-width: 110px;">
                                        <a 
                                            :href="item.state.id === 3 ? '/ponuka-bytov/'+item.apartmentHousePattern+'/'+item.pattern : '#'"
                                            @click="item.state.id === 3 ? null : $event.preventDefault()"
                                            data-mobile="Terasa"
                                        >
                                            {{ item.terrace_area }} M<sup>2</sup>
                                        </a>
                                    </td>
                                    <!-- <td class="text-center" style="min-width: 150px;">
                                        <a :href="'/ponuka-bytov/'+item.apartmentHousePattern+'/'+item.pattern" data-mobile="Cena">
                                            {{ item.price_formatted }}
                                        </a>
                                    </td> -->
                                    <td class="text-center" style="min-width: 150px;">
                                        <a 
                                            :href="item.state.id === 3 ? '/ponuka-bytov/'+item.apartmentHousePattern+'/'+item.pattern : '#'"
                                            @click="item.state.id === 3 ? null : $event.preventDefault()"
                                            data-mobile="Stav"
                                            :style="`background-color: #${ item.state.color };`"
                                        >
                                            {{ item.state.title }}
                                        </a>
                                    </td>
                                </tr>
                            </template>
                            <!--Items empty-->
                            <tr v-else>
                                <td class="py-3 text-center font-weight-normal" colspan="9">
                                    Neboli nájdené žiadne záznamy
                                </td>
                            </tr>
                        </template>
                        <!--Loader-->
                        <tr v-else>
                            <td class="py-3 text-center" colspan="9">
                                <img src="/img/icons/loader.svg" alt="loader"/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!--Pagination-->
            <div
                v-if="totalPages && !loading"
                class="text-center mb-4 mb-md-5"
            >
                <div class="pagination">
                    <template
                        v-for="pageNumber in totalPages"
                        :key="pageNumber"
                    >
                        <button
                            @click="setCurrentPage(pageNumber)"
                            :class="{ active: pageNumber === pagination.current_page }"
                        >
                            {{ pageNumber }}
                        </button>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            items: [],
            filters: [],
            filtersShow: false,
            pagination: {
                current_page: 1,
                per_page: 10,
                total: 0,
            },
            form: {
                filter: {
                    'apartment_houses.number': null,
                    'number_rooms': null,
                },
            },
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.pagination.total / this.pagination.per_page);
        },
    },
    // async created() {
    //     await this.getItems();

    //     await this.getFilters();
    // },
    async created() {
        // Read and set the 'number_rooms' query parameter from the URL
        const queryParams = new URLSearchParams(window.location.search);
        const numberRooms = queryParams.get('number_rooms');
        if (numberRooms) {
            this.form.filter.number_rooms = numberRooms;
        }

        await this.getItems();

        await this.getFilters();
    },
    methods: {
        async getItems(filter = false) {
            if (filter) {
                this.pagination.current_page = 1;
            }

            try {
                this.loading = true;

                const response = await axios.get(`/offer-flats`, {
                    params: {
                        filter: this.form.filter,
                        page: this.pagination.current_page,
                        per_page: this.pagination.per_page,
                    },
                });

                const responseData = response.data;

                this.items = responseData.items;
                this.pagination.total = responseData.pagination.total;
                this.loading = false;
            } catch (error) {
                console.log(error);
            }
        },

        async getFilters() {
            try {
                const response = await axios.get(`/offer-flats/filters`);

                this.filters = response.data;
                this.form.filter.area_min = this.filters.area_min;
                this.form.filter.area_max = this.filters.area_max;
                this.filtersShow = true;
            } catch (error) {
                console.log(error);
            }
        },

        async setCurrentPage(pageNumber) {
            if (this.pagination.current_page !== pageNumber) {
                this.pagination.current_page = pageNumber;

                await this.getItems();
                
                // Scroll to flat-table-list after pagination, accounting for 120px fixed header
                this.$nextTick(() => {
                    const tableElement = document.querySelector('.flat-table-list');
                    if (tableElement) {
                        const elementPosition = tableElement.offsetTop;
                        const offsetPosition = elementPosition - 120; // Account for 120px fixed header

                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });
                    }
                });
            }
        },
    },
};
</script>
